import { render, staticRenderFns } from "./LangIcon.vue?vue&type=template&id=0bbc80dc&scoped=true&"
import script from "./LangIcon.vue?vue&type=script&lang=ts&"
export * from "./LangIcon.vue?vue&type=script&lang=ts&"
import style0 from "./LangIcon.vue?vue&type=style&index=0&id=0bbc80dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbc80dc",
  null
  
)

export default component.exports